import React from "react";
import { Link } from "react-router-dom";
import FadeIn from "../../../components/animations/FadeIn";

const ProductsPreview = () => {

  const products = [
    {
      id: 1,
      image: "/assets/images/Modum.png",
      title: "Wireless LR RHT Sensor",
      slug: "ultra-long-range-ble-sensor",
    },
    {
      id: 2,
      image: "/assets/images/Modum1.png",
      title: "Wireless 3 Phase Ac Detection",
      slug: "3-phase-ac-detection",
    },
    {
      id: 3,
      image: "/assets/images/P3.png",
      title: "4G Eco9",
      slug: "sensor-network",
    },
    {
      id: 4,
      image: "/assets/images/P4.png",
      title: "SMART TRACK",
      slug: "smart-track",
    },
    {
      id: 5,
      image: "/assets/images/P5.png",
      title: "BLE Container Lock",
      slug: "ble-network",
    },
    {
      id: 6,
      image: "/assets/images/P6.png",
      title: "E-VAHAN TRACKER",
      slug: "e-vahan-tracker",
    },
  ];

  return (
    <section className="py-20 bg-white">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* HEADER */}

        <FadeIn>
          <div className="text-center mb-16">

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight uppercase text-gray-900/80">
              PRODUCTS WE OFFER....
            </h2>

            <div className="mt-6 max-w-5xl mx-auto space-y-6">
              <p className="text-base md:text-lg lg:text-xl text-gray-500 leading-relaxed">
                SiWi develops innovative IoT hardware and embedded systems designed
                to deliver reliable monitoring, intelligent connectivity, and actionable
                data insights for modern industries.
              </p>
            </div>

          </div>
        </FadeIn>


        {/* PRODUCT GRID */}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

          {products.map((product, index) => (

            <FadeIn key={product.id} delay={index * 0.1}>

              <Link
                to={`/products/${product.slug}`}
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="group block h-full p-4 bg-white border border-gray-200 hover:shadow-xl hover:border-gray-300 transition-all duration-300 text-center"
              >

                {/* IMAGE */}

                <div className="mb-4 flex justify-center items-center h-96 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="h-full w-full object-contain scale-150 transition-transform duration-500 group-hover:scale-[1.65]"
                  />
                </div>

                {/* TITLE */}

                <h3 className="text-base md:text-lg font-bold text-gray-900 uppercase tracking-wide">
                  {product.title}
                </h3>

              </Link>

            </FadeIn>

          ))}

        </div>

      </div>

    </section>
  );
};

export default ProductsPreview;